import { AccountPosition } from '../types';

/** Mirrors backend GENERATION_SLOT_STATUSES for open-slot counting. */
export const GENERATION_SLOT_STATUSES = new Set([
  'ACTIVE',
  'APPROVED',
  'ENTRY_PENDING',
  'PENDING_MARKET_OPEN',
  'RECOMMENDED',
  'PENDING',
]);

export function isMacroRegistryPosition(p: AccountPosition): boolean {
  return p.positionOrigin === 'macro_etf_tier1';
}

export function isThesisOrchestratorPosition(p: AccountPosition): boolean {
  if (isMacroRegistryPosition(p)) return false;
  if (p.positionOrigin === 'thesis_orchestrator') return true;
  return !p.positionOrigin;
}

export function countGenerationSlots(
  positions: AccountPosition[],
  tierId: string,
): number {
  return positions.filter(
    (p) =>
      p.tierId === tierId &&
      isThesisOrchestratorPosition(p) &&
      GENERATION_SLOT_STATUSES.has(p.status),
  ).length;
}

export function filterTier6ThesisPositions(
  positions: AccountPosition[],
  tierId: string,
): AccountPosition[] {
  return positions.filter(
    (p) => p.tierId === tierId && isThesisOrchestratorPosition(p),
  );
}
